import { Settings2 } from "lucide-react";
import { Brand } from "./Brand";

export function Header() {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Brand />
        <nav aria-label="Navegação principal">
          <a href="/#simulador">Simular</a>
          <a href="/#comparativo">Comparar</a>
          <a href="/#cronograma">Cronograma</a>
          <a className="nav-admin" href="/admin">
            <Settings2 size={16} aria-hidden="true" />
            Configuração
          </a>
        </nav>
      </div>
    </header>
  );
}

